module.exports = __webpack_public_path__ + "img/number-2.2bef100a.svg";